import { render, staticRenderFns } from "./ExhibitionSelector.vue?vue&type=template&id=39f17c2e&scoped=true&"
import script from "./ExhibitionSelector.vue?vue&type=script&lang=js&"
export * from "./ExhibitionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f17c2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
